import client from 'data/client';
import { Order } from 'data/types/order';
import { normalizeOrder } from 'model/order';

const getOrder = async (id: string) => {
  const response = await client.get<Order>(`/orders/history/${id}`);

  return normalizeOrder(response.data);
};

export default getOrder;
